import React from 'react';
import { useSelector } from 'react-redux';
import { ISideBar } from 'types';
import { SIDEBAR } from 'config/constants';
import { ShootingDetail } from '../Shootings/components';

function SideBars() {
  const { sidebars } = useSelector((state: any) => {
    return state.app;
  });

  const renderSideBar = (sidebar: ISideBar) => {
    const { type, data } = sidebar || {};

    switch (type) {
      case SIDEBAR.SHOOTING_DETAIL:
        return <ShootingDetail key='shootingDetail' shootingId={data?.shootingId} />;
      default:
        return null;
    }
  };

  return (
    <>
      {sidebars.map((m: ISideBar) => {
        return renderSideBar(m);
      })}
    </>
  );
}

export default SideBars;
